import React, { useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";

const ROUTE_MAP = [
  { path: "/dashboard", section: "Dashboard" },
  { path: "/dashboard/clients", section: "Clients" },
  { path: "/dashboard/properties", section: "Properties" },
  { path: "/dashboard/analysis", section: "Analysis" },
  { path: "/dashboard/reports", section: "Reports" },
  { path: "/dashboard/billing", section: "Billing" },
  { path: "/dashboard/settings", section: "Settings" },
  { path: "/dashboard/workspace", section: "Workspace" },
  { path: "/dashboard/layout", section: "Layout Setup" },
  { path: "/dashboard/directions", section: "Directions" },
  { path: "/dashboard/remedies", section: "Remedies" },
  { path: "/dashboard/prescriptions", section: "Prescriptions" },
  { path: "/dashboard/learn", section: "Learn" },
  { path: "/dashboard/help", section: "Help" },
  { path: "/dashboard/saved-analyses", section: "Saved Analyses" },
  { path: "/dashboard/insights", section: "Insights" },
  { path: "/dashboard/recommendations", section: "Recommendations" },
  { path: "/dashboard/devta", section: "Devta" },
  { path: "/dashboard/ayadi", section: "Ayadi" },
  { path: "/dashboard/numerology", section: "Numerology" },
  { path: "/dashboard/astro-vastu", section: "Astro Vastu" },
  { path: "/dashboard/lal-kitab", section: "Lal Kitab" },
  { path: "/billing", section: "Billing" },
];

const matchRoute = (pathname) => ROUTE_MAP.find((route) => route.path === pathname);

export default function DashboardBreadcrumbs() {
  const location = useLocation();
  const route = useMemo(
    () => matchRoute(location.pathname || ""),
    [location.pathname]
  );

  const crumbs = useMemo(() => {
    if (!route || route.path === "/dashboard") {
      return [{ label: "Dashboard", to: "/dashboard", current: true }];
    }
    return [
      { label: "Dashboard", to: "/dashboard" },
      { label: route.section, to: route.path, current: true },
    ];
  }, [route]);

  return (
    <nav aria-label="breadcrumb">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
        {crumbs.map((crumb, index) => (
          <li key={`${crumb.label}-${index}`} className="flex items-center gap-2">
            {crumb.current ? (
              <span className="max-w-[180px] truncate text-slate-700">
                {crumb.label}
              </span>
            ) : (
              <NavLink className="text-amber-600" to={crumb.to}>
                {crumb.label}
              </NavLink>
            )}
            {index < crumbs.length - 1 && <span>→</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
